import isObjEmpty from "../../../../utils/helpers/isObjectEmpty";
export function isGeorgia(value) {
  return +value === 268;
}

export function isCity(value) {
  return +value === 1;
}

export function isVillage(value) {
  return +value === 2;
}

export function isGeoCode(code) {
  return +code === 268;
}

export const cityOrVillage = [
  {
    referenceId: 1,
    referenceNameEn: "City",
    referenceNameGe: "ქალაქი",
  },
  {
    referenceId: 2,
    referenceNameEn: "Village",
    referenceNameGe: "სოფელი",
  },
];

export const fieldNames = {
  LEGAL_FORM: "legalForm",
  LEGAL_KYC_FORM: "legalKycForm",
  PRIVATE_KYC_FORM: "privateKycForm",
  CONFIRMATION_STATUS: "ConfirmationStatus",
  ORGANIZATION_LEGAL_FORM: "organizationLegalForm",
  COMPANY_NAME: "companyName",
  IDENTIFICATION_NUMBER: "IdentificationNumber",
  REGISTRATION_DATE: "registrationDate",
  REGISTRATION_COUNTRY: "registrationCountry",
  LEGAL_ADDRESS: "legalAddress",
  COUNTRY: "country",
  CITY: "city",
  CITY_VILLAGE: "cityVillage",
  VILLAGE: "village",
  STREET: "street",
  HOME_NUMBER: "homeNumber",
  APARTMENT_NUMBER: "apartmentNumber",
  ACTUAL_ADDRESS: "actualAddress",
  EMAIL_ADDRESS: "emailAddress",
  BUSINESS_ACTIVITY_DETAILS: "businessActivityDetails",
  OWNER_NAME: "ownerName",
  OWNER_LAST_NAME: "ownerLastName",
  OWNER_ID_NUMBER: "ownerIdNumber",
  BUSINESS_ACTIVITY_IN_GEORGIA: "businessActivityInGeorgia",
  BUSINESS_ACTIVITY_IN_GEORGIA_NO_DESCRIPTION:
    "businessActivityInGeorgiaNoDescription",
  EXPORT_CONNECTIONS: "exportConnections",
  CATEGORY_OF_POLITICALLY_EXPOSED: "categoryOfPoliticallyExposed",
  INFORMATION_ABOUT_RELATED_PEP: "informationAboutRelatedPep",
  PEP: "pep",
  PLEASE_SPECIFY_BANKS: "pleaseSpecifyBanks",
  ACCOUNT_PURPOSES: "accountPurposes",
  SELECTED_COUNTRY_FROM: "selectedCountryFrom",
  SELECTED_COUNTRY_TO: "selectedCountryTo",
  CAPITAL_SOURCES: "capitalSurfaces",
  INCOME_FROM_OTHER_BUSINESS_ACTIVITIES: "incomeFromOtherBusinessActivities",
  OTHER_BUSINESS_ACTIVITIES: "otherBusinessActivities",
  CAPITAL_SOURCES_IN_BANK: "capitalSurfacesInBank",
  CAPITAL_SOURCES_IN_BANK_OTHER: "capitalSurfacesInBankOther",
  DUAL_CITIZENSHIP_COUNTRY: "dual_citizenshipt_country",
  DUAL_CITIZENSHIP: "dualCitizenship",
  ACTIVITY_SUBJ: "activity_subject",
  MONTHLY_TURNOVER: "monthly_turnover",
  CASH_TURNOVER_ID: "cashTurnoverId",
  INFO_COUNTERPARTIES: "Information_on_counterparties",
  MONTHLY_INCOME: "monthly_income",
  MONEY_SOURCES: "moneySources",
  HAS_GREEN_CARD: "has_green_card",
  HAS_USA_TAXES: "has_usa_taxes",
  WHERE_YOU_HAVE_BANK_ACCOUNTS: "whereYouHaveBankAccounts",
  WEALTH_SOURCES: "wealthSources",
  ASSETS: "assets",
  OTHER_ASSETS: "other_assets",
  PLEASE_SPECIFY_WEALTH: "please_specify_wealth",
  ACTIVITY_SUBJ_COMMENT: "activity_subject_comment",
  PLEASE_SPECIFY_INCOME_SOURCE: "specify_income_source",
  PRIVACY_AGREED: "privacy_agreed",
  USA_TAXES_TYPE: "usa_taxes_type",
  USA_TAXES_TYPE_DESC: "usa_taxes_type_desc",
  STREET_INFO: "street_info",
  COUNTRY_INFO: "country_info",
  ACCOUNT_NUMS: "account_nums",
  TIN: "tin",
  COUNTRYOFBIRTH: "countryofbirth",
  CITYOFBIRTH: "cityofbirth",
  DATEOFBIRTH: "dateofbirth",
  USA_TAXES_TYPE_FEDERAL: "usa_taxes_type_federal",
  COUNTRY_CODE: "countryCode",
  IS_ACTUAL_ADDRESS: "isActualAddress",
  IS_COMPANY_EXP_IMP: "isCompanyExpImp",
  JOB_POSITION: "job_position",
  JOB: "job",
  JOB_START_DATE: "job_start_date",
  ORGANIZATION_NAME: "organization_name",
  ENTREPRENUER: "entrepreneur",
  COMPANY_LEGAL_ADDRESS: "CompanyLegalAddress",
  COMPANY_ADDRESS: "CompanyAddress",
  COMPANY_ACTUAL_ADDRESS_BOOLEAN: "CompanyActualAddressBoolean",
  OWNERS_INFO: "owners_info",
};

export const PURPOSES_OPTIONS = {
  foreignTransfers: "8",
};

export const USA_TAXES_TYPE_OPTIONS = {
  usaTaxesTypeFederal: "6",
};

export const USA_TAXES_TYPE_OPTION = {
  usaTaxesTypeDesc: "7",
};
export const ACTIVITY_SUBJ_OPTIONS = {
  job: "3",
  jobs: "9",
  jobPosition: "3",
  jobPositions: "9",
  jobStartDate: "3",
  jobStartDates: "9",
  organizationName: "2",
  entreprenuer: "1",
};

// function returns true if we have address.actualAddress.country and address.Actualaddress.homeNUmber
export function doWeHaveActualAddress(address) {
  const { [fieldNames.ACTUAL_ADDRESS]: actualAddress } = address;
  if (!actualAddress) return false;
  const { [fieldNames.COUNTRY]: country } = actualAddress;

  return !!country;
}

export function doWeHaveCompanyActualAddress(address) {
  const { [fieldNames.COMPANY_ADDRESS]: CompanyAddress } = address;
  if (!CompanyAddress) return false;
  const { [fieldNames.COUNTRY]: country } = CompanyAddress;

  return !!country;
}

// gets valuee from obj with string key (obj['value.value'])
export function getNestedValue(obj, string) {
  if (!string) {
    return null;
  }
  const values = string.split(".");
  let result = { ...obj };

  for (let i = 0; i < values.length; i++) {
    if (!result || isObjEmpty(result)) return "";
    result = result[values[i]] || "";
  }
  return result;
}

export function isContentGeorgian(lang) {
  return lang === "ka";
}

export function withNameSpace(namespace, fieldName) {
  return namespace ? `${namespace}.${fieldName}` : fieldName;
}

export function withTwoNameSpaces(namespace, secondName, fieldName) {
  return namespace ? `${namespace}.${secondName}.${fieldName}` : fieldName;
}

export function moveGeorgiaUp(data) {
  return data.sort(({ referenceId }) => {
    if (isGeorgia(referenceId)) {
      return -1;
    }
    return 1;
  });
}

export const legalKycFormOptions = (t) => [
  {
    value: "1",
    label: t("kycBasicQuestions"),
  },
  {
    value: "2",
    label: t("kycAdditionalQuestions"),
  },
  {
    value: "3",
    label: t("fullVersion"),
  },
];

export const CATEGORY_OF_POLITICALLY_EXPOSED_OPTION = {
  relatedPep: "4",
};

export const LEGAL_KYC_FORMS = {
  kycBasicQuestions: 1,
  kycAdditionalQuestions: 2,
  both: 3,
};
